import React from 'react';
import { motion } from 'framer-motion';
import styles from './LiveBadge.module.css';

interface LiveBadgeProps {
  active: boolean;
  liveLabel?: string;
  endedLabel?: string;
}

export function LiveBadge({
  active,
  liveLabel = 'LIVE',
  endedLabel = 'ENDED',
}: LiveBadgeProps) {
  if (!active) {
    return <span className={styles.ended}>{endedLabel}</span>;
  }

  return (
    <span className={styles.live}>
      <span className={styles.dot}>
        <motion.span
          className={styles['dot-ping']}
          animate={{ scale: [1, 2.5, 2.5], opacity: [0.7, 0, 0] }}
          transition={{ repeat: Infinity, duration: 1.3, ease: 'easeOut', times: [0, 0.6, 1] }}
        />
        <span className={styles['dot-core']} />
      </span>
      {liveLabel}
    </span>
  );
}
